/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ZipcodeCheckResult } from '../models/zipcode-check-result';
import { ZipcodeCheck } from '../models/zipcode-check';
@Injectable({
  providedIn: 'root',
})
class ZipcodeService extends __BaseService {
  static readonly postZipcodeCheckPath = '/zipcode/check';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Check a zipcode
   * @param params The `ZipcodeService.PostZipcodeCheckParams` containing the following parameters:
   *
   * - `postNLOnly`:
   *
   * - `body`: Check zipcode availability
   *
   * @return successful operation
   */
  postZipcodeCheckResponse(params: ZipcodeService.PostZipcodeCheckParams): __Observable<__StrictHttpResponse<Array<ZipcodeCheckResult>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.postNLOnly != null) __params = __params.set('postNLOnly', params.postNLOnly.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/zipcode/check`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ZipcodeCheckResult>>;
      })
    );
  }
  /**
   * Check a zipcode
   * @param params The `ZipcodeService.PostZipcodeCheckParams` containing the following parameters:
   *
   * - `postNLOnly`:
   *
   * - `body`: Check zipcode availability
   *
   * @return successful operation
   */
  postZipcodeCheck(params: ZipcodeService.PostZipcodeCheckParams): __Observable<Array<ZipcodeCheckResult>> {
    return this.postZipcodeCheckResponse(params).pipe(
      __map(_r => _r.body as Array<ZipcodeCheckResult>)
    );
  }
}

module ZipcodeService {

  /**
   * Parameters for postZipcodeCheck
   */
  export interface PostZipcodeCheckParams {
    postNLOnly: boolean;

    /**
     * Check zipcode availability
     */
    body: ZipcodeCheck;
  }
}

export { ZipcodeService }
